import { Typography, useMediaQuery } from "@mui/material";
import Parser, {
  DOMNode,
  domToReact,
  Element,
  HTMLReactParserOptions,
} from "html-react-parser";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { Navigate } from "react-router-dom";
import {
  AppFilterProps,
  SelectOptions,
  ValuesOfAny,
} from "../interfaces/Common";
import { getFileUrl } from "./apiService";
import routes from "./routes";

export const getCombinedString: (
  array: Array<string>,
  seperator?: string
) => string = (array: Array<string>, seperator?: string) => {
  let arrayString: string = "";
  let customSeperator = seperator ? seperator : ",";
  array.forEach((items: string, index: number) => {
    if (arrayString === "") {
      arrayString = `${items}${customSeperator} `;
    } else if (index === array.length - 1) {
      arrayString = arrayString + `${items}`;
    } else {
      arrayString = arrayString + `${items}${customSeperator} `;
    }
  });
  return arrayString;
};

export const splitCombinedStringintoArray = (
  value: string,
  seperator?: string
) => {
  let customSeperator = seperator ? seperator : ",";
  return value.split(customSeperator);
};

export const handleFilterData: (
  key: string,
  array: Array<any>
) => Array<SelectOptions> = (key: string, array: Array<any>) => {
  const set = new Set();
  const handleNull = (data: string) => {
    if (data && data !== null) {
      set.add(data);
    }
  };
  for (let i = 0; i < array?.length; i++) {
    if (array[i]) {
      const category = array[i][key] as string;
      if (category && `${category}`.includes(";")) {
        const categoryArray = category?.split(";");
        for (let j = 0; j < categoryArray.length; j++) {
          handleNull(categoryArray[j]);
        }
      } else {
        handleNull(category);
      }
    }
  }
  return [...set].map((items) => {
    return { label: items, value: items };
  }) as Array<SelectOptions>;
};

export const getYears: (start: number) => Array<SelectOptions> = (
  start: number
) => {
  const array: Array<SelectOptions> = [];
  const date = new Date();
  for (let i = start; i <= date.getFullYear(); i++) {
    array.push({
      label: `${i}`,
      value: `${i}`,
    });
  }
  return array.reverse();
};

// export const PublicRoute: React.FunctionComponent<ReactChildren> = ({
//   children,
// }) => {
//   const {
//     state: { user, isAuthenticated },
//   } = useContext(AuthContext);

//   if (isAuthenticated) {
//     if (isInvestor || hasAllRoles) {
//       return <Navigate to={routes.home} />;
//     } else if (isJuryMember) {
//       return <Navigate to={routes.juryPortal} />;
//     }
//   }
//   return children;
// };

// export const PrivateRoute: React.FunctionComponent<ReactChildren> = ({
//   children,
// }) => {
//   const {
//     state: { isAuthenticated },
//   } = useContext(AuthContext);

//   if (!isAuthenticated) {
//     return <Navigate to={routes.login} />;
//   }
//   return children;
// };

type PublicRouteProps = {
  children: JSX.Element;
  userType: "general" | "team";
};

export const PublicRoute = ({ children, userType }: PublicRouteProps) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const isTeamAuthenticated =
    localStorage.getItem("isTeamAuthenticated") === "true";

  if (userType === "general" && isAuthenticated) {
    return <Navigate to={routes.dashboard} replace />;
  }

  if (userType === "team" && isTeamAuthenticated) {
    return <Navigate to={routes.teamDashboard} replace />;
  }

  return children;
};

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  return isAuthenticated ? children : <Navigate to={routes.login} replace />;
};

export const TeamPrivateRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated =
    localStorage.getItem("isTeamAuthenticated") === "true";

  return isAuthenticated ? children : <Navigate to={routes.login} replace />;
};

export const AppFilterFunction: (props: AppFilterProps) => Array<any> = (
  props
) => {
  const { filterData, data } = props;
  if (Object.keys(filterData).length === 0) {
    return data;
  }

  const filteringData = { ...filterData };
  let sampleEventData = [...data];
  for (const i in filteringData) {
    const filteredArray = [];
    for (let j = 0; j < sampleEventData.length; j++) {
      const element = sampleEventData[j];
      if (element[i] !== null) {
        if (
          `${element[i]}`
            .toLowerCase()
            .includes(`${filteringData[i]}`.toLowerCase())
        ) {
          filteredArray.push(element);
        }
      }
    }
    sampleEventData = [...filteredArray];
  }
  return sampleEventData;
};

export function pad(n: string, width: number, z?: string) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const handleFiles = async (
  e: React.ChangeEvent<HTMLInputElement>,
  types?: Array<string>,
  size?: number
) => {
  // File Check
  if (!e.target.files) {
    return { message: "Please Upload File", success: false };
  }
  const getFile = e.target.files[0];
  const customSize = size ? size : 5000000;

  // File Type Check
  if (types) {
    const getMatch: Array<string> = types?.filter((items) => {
      return items === getFile.type;
    });
    if (getMatch.length === 0) {
      return {
        message: `Only the ${types.map((items) => {
          return `${items} `;
        })} formats are accepted`,
        success: false,
      };
    }
  }

  // File Size Check
  if (getFile.size > customSize) {
    return { message: "File is larger than 5MB", success: false };
  }
  try {
    const data = await getFileUrl(e.target.files[0]);
    if (data?.data?.success) {
      return data?.data?.data;
    } else {
      return { message: "Upload Failed, Try Again !", success: false };
    }
  } catch (err) {
    return { message: "Upload Failed, Try Again !", success: false };
  }
};

export const moneyValidator = (start: string, end: string) => {
  const salary = start === end;
  return salary ? `${start} LPA` : `${start}-${end} LPA`;
};

export const rangeValidatorPayload = (year: string) => {
  const getYears = year.split("-");
  if (getYears.length === 2) {
    return [parseInt(getYears[0]), parseInt(getYears[1])];
  } else if (getYears.length === 1) {
    return [parseInt(getYears[0]), parseInt(getYears[0])];
  } else {
    return "";
  }
};

export const uniqueArrayCreator = (array: Array<any>, key: string) => {
  return Array.from(
    new Set([
      ...array?.map((items: any) => {
        return items[key];
      }),
    ])
  );
};

export const registeredDatas = (array: Array<any>, objectKey: string) => {
  const newObject: ValuesOfAny = {};
  array?.forEach((items: any) => {
    const keyValue = items[objectKey];
    const date = moment(keyValue).format("Do MMMM YYYY");
    items["find"] = date;
    if (newObject.hasOwnProperty(date)) {
      newObject[date].push({ ...items });
    } else {
      newObject[`${date}`] = [items];
    }
  });
  return newObject;
};

export const copyFunction = (text: string) => {
  const clipboardItem = new ClipboardItem({
    "text/plain": new Blob([text], { type: "text/plain" }),
  });
  navigator.clipboard
    .write([clipboardItem])
    .then(() => {
      enqueueSnackbar({ message: "Link copied", variant: "success" });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const removeHTMLTags = (htmlString: string) => {
  return htmlString.replace(/<[^>]*>/g, "");
};

export const getUsernameFromURL = (url: string) => {
  try {
    const { hostname, pathname } = new URL(url);
    if (hostname.includes("linkedin")) {
      return pathname.split("/")[2];
    } else {
      const domainParts = hostname.split(".");
      const domain = domainParts.slice(-1).join(".");
      return `${domainParts[0]}.${domain}`;
    }
  } catch (error) {
    console.error("Invalid URL", error);
    return "";
  }
};

export const formatAmount = (amount: number) => {
  if (amount >= 1_000_000) {
    return (amount / 1_000_000).toFixed(1) + "M";
  } else if (amount >= 1_000) {
    return (amount / 1_000).toFixed(1) + "K";
  }
  return amount;
};

export const truncateText = (
  text: string | null | undefined,
  maxLength: number
) => {
  if (!text) {
    return ""; // return an empty string if text is null or undefined
  }

  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};

export const formatFundSize = (
  size: any,
  fundingProgram: string | undefined
): string => {
  const numSize = parseFloat(size);

  if (isNaN(numSize)) {
    return "Invalid number";
  }

  // Check if fundingProgram is defined before using it
  const isIndiaProgram =
    fundingProgram?.toLowerCase().startsWith("india") || false;

  let formattedValue: number;
  let unit: string;

  if (isIndiaProgram) {
    // Format in Thousands, Lakhs, Crores, etc.
    if (numSize >= 1e7) {
      formattedValue = Math.round((numSize / 1e7) * 100) / 100; // Crores with 2 decimals
      unit = "Cr";
    } else if (numSize >= 1e5) {
      formattedValue = Math.round((numSize / 1e5) * 100) / 100; // Lakhs with 2 decimals
      unit = "L";
    } else if (numSize >= 1e3) {
      formattedValue = Math.round((numSize / 1e3) * 100) / 100; // Thousands with 2 decimals
      unit = "K";
    } else {
      formattedValue = Math.round(numSize * 100) / 100; // No unit with 2 decimals
      unit = "";
    }
  } else {
    // Format in Thousands, Millions, Billions, etc.
    if (numSize >= 1e12) {
      formattedValue = Math.round((numSize / 1e12) * 100) / 100; // Trillions with 2 decimals
      unit = "T";
    } else if (numSize >= 1e9) {
      formattedValue = Math.round((numSize / 1e9) * 100) / 100; // Billions with 2 decimals
      unit = "B";
    } else if (numSize >= 1e6) {
      formattedValue = Math.round((numSize / 1e6) * 100) / 100; // Millions with 2 decimals
      unit = "M";
    } else if (numSize >= 1e3) {
      formattedValue = Math.round((numSize / 1e3) * 100) / 100; // Thousands with 2 decimals
      unit = "K";
    } else {
      formattedValue = Math.round(numSize * 100) / 100; // No unit with 2 decimals
      unit = "";
    }
  }

  return `${formattedValue}${unit}`.trim();
};

export const formatDate = (dateString: string | null): string => {
  if (!dateString) return "00-00-00";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "00-00-00";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-4);
  return `${day}-${month}-${year}`;
};

export const formatDate2 = (dateString: any) => {
  const date = new Date(dateString);
  const options: any = { day: "numeric", month: "long", year: "numeric" };
  return date.toLocaleDateString(undefined, options);
};

export const stripHtmlTags = (str: string) => {
  return str.replace(/<\/?[^>]+(>|$)/g, "");
};

export const formatCountryOfRegistration = (
  countryOfRegistration: string
): string => {
  if (!countryOfRegistration) {
    return "";
  }

  const countries = countryOfRegistration.split(";");

  if (countries.length > 1) {
    return `${countries[0]}+${countries.length - 1}`;
  }

  return countries[0] || "";
};

export const extractListItems = (html: string): string[] => {
  const matches = html?.match(/<li>(.*?)<\/li>/g);
  return matches ? matches.map((item) => item.replace(/<\/?li>/g, "")) : [];
};

export const customParser = (htmlString: string): React.ReactNode => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      // Ensure the node is an element node with attributes
      if (domNode instanceof Element && domNode.attribs) {
        if (domNode.name === "p") {
          return (
            <Typography
              sx={{ fontSize: { xs: "12px", ultraHD: "16px" }, color: "#333" }}
            >
              {domToReact(domNode.children as DOMNode[], options)}
            </Typography>
          );
        }

        // Add conditions for other HTML elements as needed
        if (domNode.name === "span") {
          return (
            <Typography
              sx={{ fontSize: { xs: "12px", ultraHD: "16px" }, color: "#666" }}
            >
              {domToReact(domNode.children as DOMNode[], options)}
            </Typography>
          );
        }
      }
    },
  };

  return Parser(htmlString, options);
};
export const useIsSmallMobile = () => {
  return useMediaQuery("(max-width:450px)");
};

export const useIsMobile = () => {
  return useMediaQuery("(max-width:700px)");
};

export const useIsMediumScreen = () => {
  return useMediaQuery("(max-width:1450px)");
};

export const formatWebsiteUrl = (website: string): string => {
  if (!website) return ""; // Return an empty string if the website is null or undefined
  return website.startsWith("https://") ? website : `https://` + website;
};

// Helper function to calculate completion percentage
export const calculatePercentage = (
  currentValue: string | number,
  targetValue: string | number
): number => {
  const current = parseFloat(currentValue as string) || 0;
  const target = parseFloat(targetValue as string) || 0;
  if (isNaN(current) || isNaN(target) || target === 0) {
    return 0;
  }
  return (current / target) * 100;
};

// events
export const splitBase64 = (base64: string) => {
  const splitData = base64.split(",");
  return splitData[1];
};
export function removeNullKeys(obj: any) {
  for (let key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === "object") {
      removeNullKeys(obj[key]);
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }
  return obj;
}

export function checkMilestoneStatus(mileStoneEndDate: any) {
  const today = new Date();
  const endDate = new Date(mileStoneEndDate);

  if (endDate > today) {
    return "On Track";
  } else {
    return "Delayed";
  }
}

export const PhoneNumber = (phone: any) => {
  if (!phone || phone.length < 10) return phone;

  const numberPart = phone.replace(/\D/g, "");

  if (numberPart.length >= 10) {
    return `+${numberPart.slice(0, 2)} ${numberPart.slice(-10)}`;
  }
  return phone;
};

export const formatToIndianCurrencyWords = (
  value: number | null | undefined
): string => {
  if (!value || value <= 0) return "-";

  const formatValue = (num: number) => {
    return Number.isInteger(num)
      ? num.toString()
      : num.toFixed(2).replace(/\.00$/, "");
  };

  if (value >= 1_00_00_000) {
    const croreValue = value / 1_00_00_000;
    return `₹${formatValue(croreValue)} Cr`;
  } else if (value >= 1_00_000) {
    const lakhValue = value / 1_00_000;
    return `₹${formatValue(lakhValue)} Lakhs`;
  } else if (value >= 1_000) {
    const thousandValue = value / 1_000;
    return `₹${formatValue(thousandValue)} thousand`;
  } else {
    return `₹${value.toLocaleString("en-IN")}`;
  }
};

export const formatToIndianCurrencyWords2 = (
  value: number | null | undefined
): string => {
  if (!value || value <= 0) return "-";

  const formatValue = (num: number) => {
    return Number.isInteger(num)
      ? num.toString()
      : num.toFixed(2).replace(/\.00$/, "");
  };

  if (value >= 1_00_00_000) {
    const croreValue = value / 1_00_00_000;
    return `₹${formatValue(croreValue)} Cr`;
  } else {
    const lakhValue = value / 1_00_000;
    return `₹${formatValue(lakhValue)} L`;
  }
};

export const splitCurrencyValueAndUnit = (value: number) => {
  if (value >= 1e7) {
    return { value: (value / 1e7).toFixed(2), unit: "CRORES" };
  } else if (value >= 1e5) {
    return { value: (value / 1e5).toFixed(2), unit: "LAKHS" };
  } else if (value >= 1e3) {
    return { value: (value / 1e3).toFixed(2), unit: "THOUSANDS" };
  }
  return { value: value.toString(), unit: "" };
};

export const extractStatByRole = (player: any) => {
  const role = player?.role;
  const statsArray = Array.isArray(player?.stats) ? player.stats : [];

  let battingStat: any = null;
  let bowlingStat: any = null;

  // Only get the FIRST T20 stat per record type
  for (const stat of statsArray) {
    const isT20 = stat?.matchType === "T20";
    const recordType = stat?.recordType;

    if (isT20 && recordType === "Batting" && !battingStat) {
      battingStat = stat;
    }

    if (isT20 && recordType === "Bowling" && !bowlingStat) {
      bowlingStat = stat;
    }

    if (battingStat && bowlingStat) break; // Found both
  }

  if (role === "All - rounder") {
    return {
      runs: battingStat?.totalRuns ?? "-",
      wickets: bowlingStat?.totalwickets ?? "-",
      matches: battingStat?.matches ?? bowlingStat?.matches ?? "-",
    };
  }

  if (role === "Bowler") {
    return {
      runs: "-",
      wickets: bowlingStat?.totalwickets ?? "-",
      matches: bowlingStat?.matches ?? "-",
    };
  }

  if (role === "Batsman" || role === "Wicketkeeper") {
    return {
      runs: battingStat?.totalRuns ?? "-",
      wickets: "-",
      matches: battingStat?.matches ?? "-",
    };
  }

  // Fallback for undefined roles
  return {
    runs: "-",
    wickets: "-",
    matches: "-",
  };
};

export const formatDOB = (dob: string) => {
  if (!dob) return "";
  const date = new Date(dob);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const mapHighestLevelToCategory = (highestLevel: string) => {
  if (!highestLevel) return "Unknown";

  const level = highestLevel.toLowerCase();

  if (level.includes("indian senior")) {
    return "Icon Player";
  }

  if (
    level.includes("first class") ||
    level.includes("list a") ||
    level.includes("bcc") || // catching "BCCI Senior Men T20"
    level.includes("senior men t20")
  ) {
    return "Senior Player";
  }

  if (
    level.includes("under 23") ||
    level.includes("under 19") ||
    level.includes("u-23") ||
    level.includes("u-19") ||
    level.includes("age group")
  ) {
    return "Emerging Player";
  }

  if (level.includes("local club") || level.includes("club team")) {
    return "Development Player";
  }

  return "Unknown";
};

export const teamGradients: Record<string, { from: string; to: string }> = {
  "Aakash Tigers MWS": { from: "#FD7E00", to: "#0064FF" },
  "Arcs Andheri": { from: "#263C90", to: "#8C2B8E" },
  "Eagle Thane Strikers": { from: "#FBC92E", to: "#262262" },
  "Bandra Blasters": { from: "#4B1C86", to: "#E51C21" },
  "North Mumbai Panthers": { from: "#FEB713", to: "#5F4200" },
  "MSC Maratha Royals": { from: "#1000A1", to: "#B84124" },
  "SoBo Mumbai Falcons": { from: "#F47B06", to: "#882626" },
  "Triumph Knights Mumbai North East": { from: "#E8D273", to: "#9E7437" },
};

export const getRoleType = (player: any): string => {
  if (!player || !player.role) return "Unknown";

  if (player.role === "Batsman") {
    const batting = player.stats?.find(
      (stat: any) => stat.recordType === "Batting" && stat.batting?.type
    );
    return batting?.batting?.type
      ? `${batting.batting.type} Batsman`
      : "Batsman";
  }

  if (player.role === "Bowler") {
    const bowling = player.stats?.find(
      (stat: any) => stat.recordType === "Bowling" && stat.bowling?.type
    );
    return bowling?.bowling?.type ? `${bowling.bowling.type} Bowler` : "Bowler";
  }

  if (
    player.role === "Batting - All rounder" ||
    player.role === "Bowling - All rounder"
  ) {
    const stat = player.stats?.find(
      (stat: any) => stat.batting?.type || stat.bowling?.type
    );
    const type = stat?.batting?.type || stat?.bowling?.type;
    return type ? `${type} ${player.role}` : player.role;
  }

  if (player.role === "Wicket keeper") {
    return "Wicket keeper";
  }

  return player.role;
};

export const formatPathToTitle = (path: string): string => {
  const lastSegment = path.split("/").filter(Boolean).pop();
  if (!lastSegment) return "";

  return lastSegment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const totalBudget: any = 10000000;
const basePrices: Record<string, number> = {
  "Icon Player": 2000000,
  "Senior Player": 500000,
  "Emerging Player": 300000,
  "Development Player": 200000,
};

const MIN_COUNTS = {
  "Icon Player": 1,
  "Senior Player": 4,
  "Emerging Player": 6,
  "Development Player": 5,
};

const MAX_COUNTS = {
  "Icon Player": 1,
  "Senior Player": 6,
  "Emerging Player": 8,
  "Development Player": 7,
};

const TOTAL_PLAYER_LIMIT = 18;

export const calculateTeamStatus = (players: any[], teams: any[]) => {
  return teams.map((team: any) => {
    const teamPlayers = players.filter(
      (p: any) => p.soldToId === team.Id && p.auctionResult === "Sold"
    );

    const categoryCounts: Record<string, number> = teamPlayers.reduce(
      (acc, player) => {
        const category = mapHighestLevelToCategory(
          player.recentCompetetionLevel
        );
        acc[category] = (acc[category] || 0) + 1;
        return acc;
      },
      {} as Record<string, number>
    );

    let remainingMinSpend = 0;
    for (const category in MIN_COUNTS) {
      const bought = categoryCounts[category as keyof typeof MIN_COUNTS] || 0;
      const needed = Math.max(
        MIN_COUNTS[category as keyof typeof MIN_COUNTS] - bought,
        0
      );
      remainingMinSpend +=
        needed * basePrices[category as keyof typeof MIN_COUNTS];
    }

    const currentPlayerCount = teamPlayers.length;
    const remainingPlayers = TOTAL_PLAYER_LIMIT - currentPlayerCount;
    const remainingFund = team?.Fund_Remaining__c || 0;

    const canMeetQuota =
      remainingFund >= remainingMinSpend &&
      currentPlayerCount <= TOTAL_PLAYER_LIMIT;

    return {
      ...team,
      categoryCounts,
      playerCount: currentPlayerCount,
      remainingMinSpend,
      canMeetQuota,
      status: canMeetQuota
        ? currentPlayerCount === TOTAL_PLAYER_LIMIT
          ? "Complete"
          : "Eligible"
        : "No fund",
    };
  });
};

type PlayerCategory = "Icon" | "Senior" | "Emerging" | "Development";

interface Player {
  id: string;
  name: string;
  price: number;
  category: PlayerCategory;
}

interface TeamState {
  players: Player[];
  totalSpent: number;
}

const BASE_PRICES: Record<PlayerCategory, number> = {
  Icon: 2000000,
  Senior: 500000,
  Emerging: 300000,
  Development: 200000,
};

const MIN_QUOTAS: Record<PlayerCategory, number> = {
  Icon: 1,
  Senior: 4,
  Emerging: 6,
  Development: 5,
};

const MAX_QUOTAS: Record<PlayerCategory, number> = {
  Icon: 1,
  Senior: 6,
  Emerging: 8,
  Development: 7,
};

const TOTAL_PLAYERS_REQUIRED = 18;
const TOTAL_BUDGET = 10000000;
const RESERVED_BUDGET = 6800000 + 400000; // ₹72L
const EXTRA_KITTY = TOTAL_BUDGET - RESERVED_BUDGET; // ₹28L

export function validateAuctionForPlayer(teamData: any, playerData: any) {
  // Step 1: Transform team
  const players: Player[] = (
    teamData?.Player_Registrations__r?.records || []
  ).map((p: any) => ({
    id: p.Id,
    name: p.Player__r?.Name,
    price: p.Winning_Bid__c || p.Base_Price__c,
    category: (() => {
      const price = p.Base_Price__c;
      if (price === 2000000) return "Icon";
      if (price === 500000) return "Senior";
      if (price === 300000) return "Emerging";
      if (price === 200000) return "Development";
      return "Senior";
    })(),
  }));

  const team: TeamState = {
    players,
    totalSpent: teamData?.Fund_Utilized__c || 0,
  };

  // Step 2: Transform player
  const incomingPlayer: Player = {
    id: playerData?.playerRegId,
    name: playerData?.name,
    price: playerData?.basePrice,
    category: (() => {
      const price = playerData?.basePrice;
      if (price === 2000000) return "Icon";
      if (price === 500000) return "Senior";
      if (price === 300000) return "Emerging";
      if (price === 200000) return "Development";
      return "Senior";
    })(),
  };

  // Step 3: Count current categories
  const categoryCounts: Record<PlayerCategory, number> = {
    Icon: 0,
    Senior: 0,
    Emerging: 0,
    Development: 0,
  };

  for (const p of team.players) {
    categoryCounts[p.category]++;
  }

  const currentPlayerCount = team.players.length;
  const currentSpend = team.totalSpent;

  // 1. Player count cap
  if (currentPlayerCount >= TOTAL_PLAYERS_REQUIRED) {
    return {
      valid: false,
      reason: "Team already has 18 players",
      kittyStatus: "critical",
      extraKittyRemaining: 0,
    };
  }

  // 2. Category cap
  if (
    categoryCounts[incomingPlayer.category] >=
    MAX_QUOTAS[incomingPlayer.category]
  ) {
    return {
      valid: false,
      reason: `Too many players in ${incomingPlayer.category} category`,
      kittyStatus: "critical",
      extraKittyRemaining: 0,
    };
  }

  // 3. Budget overflow
  const projectedSpend = currentSpend + incomingPlayer.price;
  if (projectedSpend > TOTAL_BUDGET) {
    return {
      valid: false,
      reason: "Not enough budget to buy this player",
      kittyStatus: "critical",
      extraKittyRemaining: 0,
    };
  }

  // 4. Remaining slots
  const remainingSlots = TOTAL_PLAYERS_REQUIRED - (currentPlayerCount + 1);

  // 5. Minimum spend to complete team
  let minSpendToComplete = 0;
  for (const category in MIN_QUOTAS) {
    const cat = category as PlayerCategory;
    const required = MIN_QUOTAS[cat];
    const have =
      categoryCounts[cat] + (incomingPlayer.category === cat ? 1 : 0);
    const stillNeeded = Math.max(required - have, 0);
    minSpendToComplete += stillNeeded * BASE_PRICES[cat];
  }

  // Include 2L * remaining slots for completion
  minSpendToComplete += remainingSlots * 200000;

  const remainingBudgetAfter = TOTAL_BUDGET - projectedSpend;

  if (remainingBudgetAfter < minSpendToComplete) {
    return {
      valid: false,
      reason: `Buying this player leaves insufficient budget to fulfill remaining quotas and players (need ₹${minSpendToComplete})`,
      kittyStatus: "critical",
      extraKittyRemaining: 0,
    };
  }

  // 6. Kitty calculation
  const extraKittyRemaining =
    TOTAL_BUDGET -
    projectedSpend -
    (RESERVED_BUDGET - (TOTAL_BUDGET - currentSpend));

  let kittyStatus: "healthy" | "low" | "critical";
  if (extraKittyRemaining >= 1000000) {
    kittyStatus = "healthy";
  } else if (extraKittyRemaining >= 100000) {
    kittyStatus = "low";
  } else {
    kittyStatus = "critical";
  }

  return {
    valid: true,
    reason: "",
    kittyStatus,
    extraKittyRemaining,
  };
}

export const validateTeamSelectionStatus = (
  team: any,
  selectedPlayer: any,
  playerDetails: any,
  KITTY_ALLOCATION: any,
  MINIMUM_PURSE: any,
  RESERVE_FOR_EXTRAS: any,
  bidAmount: any
): any => {
  console.log(
    team,
    "team",
    selectedPlayer,
    "selected player",
    playerDetails,
    "playerdetails",
    bidAmount,
    "bidAmount",
    KITTY_ALLOCATION,
    "KITTY_ALLOCATION",
    RESERVE_FOR_EXTRAS,
    "RESERVE_FOR_EXTRAS",
    MINIMUM_PURSE,
    "MINIMUM_PURSE"
  );

  if (!selectedPlayer || !playerDetails) return false;
  const category = mapHighestLevelToCategory(
    selectedPlayer?.recentCompetetionLevel || selectedPlayer?.highest_level_played
  );
  // const playersOfTeam = playerDetails.filter(
  //   (p: any) => p.soldToId === team.Id && p.auctionResult === "Sold"
  // );
  const playersOfTeam = [];
  let totalkittyamt: any = 0;
  let baseAmount = 0;
  let totalplayerCount: any = {
    "Icon Player": 0,
    "Senior Player": 0,
    "Emerging Player": 0,
    "Development Player": 0,
  };
  for (let i = 0; i < playerDetails.length; i++) {
    let p = playerDetails[i];
    if (p.soldToId === team.Id && p.auctionResult === "Sold") {
      playersOfTeam.push(p);
      totalkittyamt = totalkittyamt + (p.kittyBidAmount || 0);
      baseAmount = baseAmount + (p.reserveBidAmount || 0);
      let role = mapHighestLevelToCategory(p?.recentCompetetionLevel);
      if (totalplayerCount.hasOwnProperty(role as keyof typeof basePrices)) {
        totalplayerCount[role as keyof typeof basePrices] =
          totalplayerCount[role as keyof typeof basePrices] + 1;
      }
    }
  }

  // Calculate current category counts and required minimums
  const { currentCounts, totalPlayers } = calculateCurrentCounts(playersOfTeam);
  // const remainingFund = team?.Fund_Remaining__c || 0;

  let balanceKitty = KITTY_ALLOCATION - totalkittyamt;
  let balanceBase = MINIMUM_PURSE + RESERVE_FOR_EXTRAS - baseAmount;

  if (
    currentCounts[category as keyof typeof MIN_COUNTS] + 1 <=
    MIN_COUNTS[category as keyof typeof MIN_COUNTS]
  ) {
    if (bidAmount <= basePrices[category as keyof typeof basePrices]) {
      return {
        valid: true,
        status: "eligible",
        message: `Bid amount is equal to base price`,
      };
    } else {
      let extraKittyAmt =
        bidAmount - basePrices[category as keyof typeof basePrices];
      let balanceKittyCalc = balanceKitty - extraKittyAmt;
      if (balanceKittyCalc >= 0) {
        return {
          valid: true,
          status: "eligible",
          message: `Bid amount is equal to base price`,
        };
      } else {
        console.log(
          `Exceeds kitty by ₹${extraKittyAmt.toLocaleString("en-IN")}`
        );
        return {
          valid: false,
          status: "No Fund",
          message: `Insufficient Funds `,
        };
      }
    }
  } else if (
    currentCounts[category as keyof typeof MIN_COUNTS] + 1 <=
      MAX_COUNTS[category as keyof typeof MAX_COUNTS] &&
    playersOfTeam.length + 1 <= 18 &&
    (balanceKitty > 0 || bidAmount == RESERVE_FOR_EXTRAS / 3)
  ) {
    if (balanceKitty == 0) {
      if (bidAmount == basePrices[category as keyof typeof basePrices]) {
        return {
          valid: true,
          status: "eligible",
          message: `Bid amount is equal to base price`,
        };
      } else if (bidAmount >= basePrices[category as keyof typeof basePrices]) {
        console.log("error", `Insufficient Funds`);
        return {
          valid: false,
          status: "No Fund",
          message: `Exceeds kitty `,
        };
      } else return true;
    } else {
      if (balanceKitty > 0) {
        let extraPlayerDeltaBaseAmount = bidAmount - RESERVE_FOR_EXTRAS / 3; //300000
        if (extraPlayerDeltaBaseAmount > balanceKitty) {
          console.log("error", `Insufficient Funds`);
          return {
            valid: false,
            status: "No Fund",
            message: `Insufficient Funds `,
          };
        } else if (extraPlayerDeltaBaseAmount <= balanceKitty) {
          return {
            valid: true,
            status: "eligible",
            message: `Bid amount is equal to base price`,
          };
        }
      }
      return true;
    }
  } else {
    console.log("error", `Player limit exceeded`);
    return {
      valid: false,
      status: "No Fund",
      message: `Player limit exceeded `,
    };
  }
};

const calculateCurrentCounts = (players: any[]) => {
  const categoryCounts = players.reduce((acc, player) => {
    const cat = mapHighestLevelToCategory(player?.recentCompetetionLevel);
    acc[cat] = (acc[cat] || 0) + 1;
    return acc;
  }, {});

  return {
    currentCounts: {
      "Icon Player": categoryCounts["Icon Player"] || 0,
      "Senior Player": categoryCounts["Senior Player"] || 0,
      "Emerging Player": categoryCounts["Emerging Player"] || 0,
      "Development Player": categoryCounts["Development Player"] || 0,
    },
    totalPlayers: players?.length,
  };
};
